export default {
  inserted(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { // 当图片进入视口
          el.src = binding.value // 将指令的值赋给src，开始加载
          observer.unobserve(el) // 加载后停止观察
        }
      })
    })
    observer.observe(el) // 开始观察这个元素
  }
}